import React, { createContext, ReactElement, useContext } from 'react';

import { ReadWidgetData } from 'use-case/widgets/data/read/readWidgetDataUseCase';
import { ReadWidget } from 'use-case/widget/read/readWidgetUseCase';
import { UpdateWidget } from 'use-case/widget/update/updateWidgetUseCase';
import { CreateWidget } from 'use-case/widgets/create/createWidgetUseCase';
import { DeleteWidget } from 'use-case/widgets/delete/deleteWidgetUseCase';
import { DeleteDashboardAnalysis } from 'use-case/analysis/deleteDashboardAnalysis/deleteDashboardAnalysisUseCase';

export type WidgetDispatch = {
    updateWidget: UpdateWidget;
    readWidget: ReadWidget;
    readWidgetData: ReadWidgetData;
    createWidget: CreateWidget;
    deleteWidget: DeleteWidget;
    deleteDashboardAnalysis: DeleteDashboardAnalysis;
};

export type WidgetProviderType = {
    updateWidget: UpdateWidget;
    readWidget: ReadWidget;
    readWidgetData: ReadWidgetData;
    createWidget: CreateWidget;
    deleteWidget: DeleteWidget;
    deleteDashboardAnalysis: DeleteDashboardAnalysis;
    children: ReactElement;
};

export const WidgetContext = createContext({} as WidgetDispatch);

export const useWidget = (): WidgetDispatch => useContext(WidgetContext);

export const WidgetProvider = (props: WidgetProviderType): ReactElement => {
    const { children, updateWidget, readWidget, readWidgetData, createWidget, deleteWidget, deleteDashboardAnalysis } = props;

    return (
        <WidgetContext.Provider
            value={{
                updateWidget,
                readWidget,
                readWidgetData,
                createWidget,
                deleteWidget,
                deleteDashboardAnalysis,
            }}
        >
            {children}
        </WidgetContext.Provider>
    );
};

export default useWidget;
